import { DropdownMenuProps } from "@radix-ui/react-dropdown-menu";

import { DropdownMenu, DropdownMenuTrigger } from "@/components/atoms/ui/dropdown-menu";
import { IGIREMenuItem } from "@/router/models/router.types";

import { DropdownMenuContent } from "./DropdownMenuContent";
import { DropdownMenuItem } from "./DropdownMenuItem";
import { ItemLevel0Template } from "./ItemLevel0Template";
import { ItemLevel1 } from "./ItemLevel1Template";

type Props = DropdownMenuProps & {
  item: IGIREMenuItem;
};

export function StartMenu({ item, ...props }: Props) {
  if (!item?.items || item.items.length === 0) return null;

  return (
    <DropdownMenu {...props}>
      <DropdownMenuTrigger asChild>
        <ItemLevel0Template item={item} />
      </DropdownMenuTrigger>

      <DropdownMenuContent align="start" className="min-w-[190px]">
        {item.items.map((subItem) => (
          <DropdownMenuItem key={String(subItem.url ?? subItem.label)} asChild>
            <ItemLevel1 item={subItem} />
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
